import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    invoicesList: {
      data: [],
      status: statuses.EMPTY,
    },
    invoicesListFilters: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceClassifiers: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceCreateData: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceUpdateData: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceMediaList: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceCreate: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceDeleteAttachment: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceItemsList: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceItemsUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceUpdateDetainedPayment: {
      data: [],
      status: statuses.EMPTY,
    },
    invoicePaymentApprove: {
      data: [],
      status: statuses.EMPTY,
    },
    invoicePaymentReject: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceActivity: {
      data: [],
      status: statuses.EMPTY,
    },
    invoiceDelete: {
      data: [],
      status: statuses.EMPTY,
    },
    newInvoiceFtpFiles: {},
    newInvoiceFiles: {}
  };
};

const Invoices = {
  namespaced: true,
  state: defaultState,
  getters: {
    invoicesList: (state) => state.invoicesList,
    invoicesListFilters: (state) => state.invoicesListFilters,
    invoiceClassifiers: (state) => state.invoiceClassifiers,
    invoiceCreateData: (state) => state.invoiceCreateData,
    invoiceUpdateData: (state) => state.invoiceUpdateData,
    invoiceMediaList: (state) => state.invoiceMediaList,
    invoiceCreate: (state) => state.invoiceCreate,
    invoiceUpdate: (state) => state.invoiceUpdate,
    invoiceDeleteAttachment: (state) => state.invoiceDeleteAttachment,
    invoiceItemsList: (state) => state.invoiceItemsList,
    invoiceItemsUpdate: (state) => state.invoiceItemsUpdate,
    invoiceUpdateDetainedPayment: (state) => state.invoiceUpdateDetainedPayment,
    invoicePaymentApprove: (state) => state.invoicePaymentApprove,
    invoicePaymentReject: (state) => state.invoicePaymentReject,
    invoiceActivity: (state) => state.invoiceActivity,
    invoiceDelete: (state) => state.invoiceDelete,
    newInvoiceFtpFiles: (state) => state.newInvoiceFtpFiles,
    newInvoiceFiles: (state) => state.newInvoiceFiles
  },
  mutations,
  actions,
};

export { Invoices, defaultState };
